import THEME from "../../../theme";
import { fs } from "../utils/styles";

export default function WiederkehrendeKosten({ zahlungen }) {
  return (
    <div style={fs.karte}>
      <h3 style={{ color: THEME.colors.text, marginTop: 0 }}>Wiederkehrende Kosten</h3>
      {zahlungen.length === 0 ? (
        <p style={{ color: THEME.colors.textMuted, margin: 0 }}>Noch keine wiederkehrenden Zahlungen bestätigt.</p>
      ) : (
        <div style={fs.tabelle}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead><tr><th style={fs.th}>Name</th><th style={fs.th}>Rhythmus</th><th style={{ ...fs.th, textAlign: "right" }}>⌀ Betrag</th><th style={fs.th}>Letzte Buchung</th></tr></thead>
            <tbody>
              {zahlungen.map(w => (
                <tr key={w.id}>
                  <td style={fs.td}>{w.name}</td>
                  <td style={fs.td}>{w.rhythmus || "–"}</td>
                  <td style={{ ...fs.td, textAlign: "right" }}>{w.erwarteter_betrag != null ? `${w.erwarteter_betrag.toFixed(2)} €` : "–"}</td>
                  <td style={fs.td}>{w.letzte_buchung || "–"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
